/**
 * PAPPO — ForgotPasswordPage
 * Stub: campo de email + botão de envio + link para voltar ao login.
 */

import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import { Button } from '../components/common/Button';
import { Input } from '../components/common/Input';
import { forgotPassword } from '../services/auth';
import styles from './ForgotPasswordPage.module.css';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsLoading(true);
    // Envio real: o backend responde sempre igual (não revela se o email
    // existe), então mostramos a confirmação genérica em qualquer caso.
    await forgotPassword(email.trim());
    setIsLoading(false);
    setSent(true);
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <h1 className={styles.title}>Esqueci a Senha</h1>
          <p className={styles.subtitle}>Enviaremos um link de recuperação</p>
        </div>

        {!sent ? (
          <form onSubmit={handleSubmit} className={styles.form}>
            <Input
              label="Email"
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              leftIcon={<Mail size={16} />}
              autoComplete="email"
            />
            <Button type="submit" fullWidth isLoading={isLoading} size="lg">
              Enviar Instruções
            </Button>
          </form>
        ) : (
          <div className={styles.success}>
            <p>📧 Se este email tiver uma conta, enviamos um link de redefinição.</p>
            <p>Confira sua caixa de entrada (e o spam). O link expira em 1 hora.</p>
          </div>
        )}

        <div className={styles.links}>
          <Link to="/login" className={styles.backLink}>
            <ArrowLeft size={16} />
            Voltar ao login
          </Link>
        </div>
      </div>
    </div>
  );
}
